<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">打卡排班添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-row>
                    <el-col :span="24" class="item">
                        <el-card class="box-card" shadow='never' :body-style='{padding:0}'>
                            <div slot="header" class="clearfix">
                                <span>打卡组列表</span>
                                <el-button style="float: right;transform: translate(0px, -9px);" type="primary" @click="showModal">添加</el-button>
                            </div>
                            <template>
                                <el-table
                                    :data="planData"
                                    style="width: 100%" border>
                                    <el-table-column prop="startTime" label="上班时间"></el-table-column>

                                    <el-table-column prop="endTime" label="下班时间"></el-table-column>

                                    <el-table-column fixed="right" label="操作" width="200">
                                        <template slot-scope="scope">
                                            <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                                            <el-button type="danger" size="small" @click.native.prevent="deleteRow(scope.$index, planData)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-card> 
                    </el-col>
                </el-row>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
        <el-dialog :title='title' :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false' :modal-append-to-body='false'>    
            <el-form ref="addInfo">
                <el-form-item label="上班时间" required>
                    <el-time-select
                        style="width:100%"
                        placeholder="上班时间"
                        v-model="startTime"
                        :picker-options="{
                        start: '01:00',
                        step: '00:30',
                        end: '23:30',
                        
                        minTime:startTimes,
                        maxTime:endTime
                        }">
                    </el-time-select>
                </el-form-item>
                <el-form-item label="下班时间" required>
                    <el-time-select
                        style="width:100%"
                        placeholder="下班时间"
                        v-model="endTime"
                        :picker-options="{
                        start: '01:00',
                        step: '00:30',
                        end: '23:30',
                        minTime:startTime,
                        maxTime:endTimes
                        }">
                    </el-time-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchDialog=false">取 消</el-button>
                <el-button type="primary"  @click="addSub">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['dishesList'],
        data() {
            return {
                loading: false,
                batchDialog: false,
                floor:null,
                title:'排班添加',
                dataIndex:-1,
                planData:[],
                startTimes:'01:00',
                endTimes:'23:30',
                startTime:'',
                endTime:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    timeArr:[],
                    clockPlanItemList:[]
                },
            }
        },

        methods: {
            init(dateList){
                this.planData=[]
                // this.$refs.addForm.resetFields();
                this.addForm.timeArr=dateList
            },
            showModal(){
                this.batchDialog=true
                this.title='排班添加'
                this.startTime=''
                this.endTime=''
                this.dataIndex=-1
                if(this.planData.length==0){
                    this.startTimes='01:00'
                }else{
                    this.startTimes=this.planData[this.planData.length-1].endTime
                }
                this.endTimes='23:30'
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            deleteRow(index, rows){
                rows.splice(index, 1);
            },
            handleEdit(index,row){
                this.dataIndex=index
                this.title='排班编辑'
                this.startTime=row.startTime
                this.endTime=row.endTime
                // this.startTimes=this.planData[index-1].endTime
                // this.endTimes=this.planData[index+1].startTime
                if(index==0){
                    this.startTimes='01:00'
                }else{
                    this.startTimes=this.planData[index-1].endTime
                }
                if(index==this.planData.length-1){
                    this.endTimes='23:30'
                }else{
                    this.endTimes=this.planData[index+1].startTime
                }
                this.batchDialog=true
            },
            confirm(){
                if(this.planData.length>0){
                    this.addSubmit();
                }else{
                    this.$message({type: 'info', message: '排班不能为空'});
                    return ;
                }

            },
            addSub(){
                if(!this.startTime){
                    this.$message.error('请选择上班时间')
                    return;
                }
                if(!this.endTime){
                    this.$message.error('请选择下班时间')
                    return;
                }
                if(this.dataIndex>=0){
                    this.$set(this.planData[this.dataIndex],'startTime', this.startTime);
                    this.$set(this.planData[this.dataIndex],'endTime', this.endTime);
                }else{
                    var data={startTime:this.startTime,endTime:this.endTime}
                    this.planData.push(data)
                }
                this.batchDialog=false
            },
            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.clockPlanItemList=this.getItemList()
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ClockinPlan/AddMany",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            getItemList(){
                var array=[]
                var list=this.planData
                list.forEach(element => {
                    array.push({clockinTime:element.startTime+':00',clockinType:1})
                    array.push({clockinTime:element.endTime+':00',clockinType:2})
                });
                return array
            }


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width:700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .box-card{
                margin: 10px 0;
            }
            .dishesPlanAdd{
                float: right;transform: translate(0px, -9px);
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
